/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digipass'
export default icon
